import { useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import { SlotImage } from '@/features/designer/components/SlotImage'

export function HashtagBannerSection() {
  const sectionRef = useRef<HTMLElement>(null)

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ['start end', 'center center'],
  })

  // Slides from above the section down to top-aligned resting position
  const y = useTransform(scrollYProgress, [0, 1], [-300, 0])

  return (
    <section ref={sectionRef} className="relative overflow-hidden h-[25vh] md:h-[70vh]">
      <SlotImage
        slotKey="homepage-moveonfilm"
        className="absolute inset-0 w-full h-full"
        alt="#MOVEONFILM background"
        fallback={
          <div className="absolute inset-0 bg-gradient-to-br from-brand-black to-brand-blue-dark" />
        }
      />

      <div className="absolute inset-x-0 top-0 z-10 flex justify-center pointer-events-none">
        <motion.img
          src="/moveonfilm.png"
          alt="#MOVEONFILM"
          style={{ y }}
          className="w-full"
        />
      </div>
    </section>
  )
}
